import { render, staticRenderFns } from "./ConfigureLimit.vue?vue&type=template&id=93129cac"
import script from "./ConfigureLimit.vue?vue&type=script&lang=js"
export * from "./ConfigureLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports